export default __webpack_public_path__ + "d014a65b33d916e5f0e84ba693b1b841.svg";